module.exports = __webpack_public_path__ + "img/stock0.13912670.png";